import { InputTypes } from 'constants/enums';
import { IEvaluationQuestionType, IFormField } from 'models/app';
import React from 'react';
import Modal from 'components/UI/DialogModal';
import Form from 'components/UI/Form';
import { CircularProgress, Grid, Stack } from '@mui/material';
import MuiButton from 'components/UI/MuiButton';
import { useTranslation } from 'react-i18next';
import { IWorkshopEvaluationQuestion } from 'models/workshopEvaluationQuestions';
import { IWorkshopEvaluationQuestionDimension } from 'models/workshopEvaluationQuestionDimension';
import { ICompanyCompetency } from 'models/companyCompetencies';
import { IVendorAssessmentQuestion } from 'models/vendorAssessmentQuestion';


interface Props {
  open: boolean;
  loading: boolean;
  types: IEvaluationQuestionType[];
  vendorAssessmentQuestion: IVendorAssessmentQuestion;
  onClose: () => void;
  onSubmit: () => void;
  onChanges: (name: string, value: any) => void;
}

const EditIndustry: React.FC<Props> = ({ open, loading, types, vendorAssessmentQuestion, onClose, onSubmit, onChanges }) => {
  const { t } = useTranslation()
  let typesOptions = types.map((type) => {
    return { value: type.id.toString(), label: type.description };
  });

  let basicFields: IFormField[] = [
    {
      name: 'title',
      label: t('T_enter_title'),
      placeholder: t('T_enter_title'),
      type: InputTypes.TEXT,
      defaultValue: vendorAssessmentQuestion.title,
      internalLabel: true,
      required: true
    },
    {
      name: 'titleAr',
      label: `${t('T_enter_title')} ${t('T_in_arabic')}`,
      placeholder: `${t('T_enter_title')} ${t('T_in_arabic')}`,
      type: InputTypes.TEXT,
      defaultValue: vendorAssessmentQuestion.titleAr,
      internalLabel: true
    },
    {
      name: 'description',
      label: t('T_enter_description'),
      placeholder: t('T_enter_description'),
      type: InputTypes.TEXT,
      defaultValue: vendorAssessmentQuestion.description,
      internalLabel: true
    },
    {
      name: 'descriptionAr',
      label: `${t('T_description')} ${t('T_in_arabic')}`,
      type: InputTypes.TEXT,
      placeholder: `${t('T_description')} ${t('T_in_arabic')}`,
      defaultValue: vendorAssessmentQuestion.descriptionAr,
      internalLabel: true
    },
    {
      name: 'questionOrder',
      label: t('T_is_active'),
      placeholder: t('T_enter_order'),
      type: InputTypes.TEXT,
      defaultValue: vendorAssessmentQuestion.questionOrder,
      internalLabel: true,
      required: true
    },
    {
      name: 'questionType',
      label: t('T_type'),
      placeholder: t('T_select_type'),
      type: InputTypes.SELECT,
      defaultValue: typesOptions.find(x => x.value == vendorAssessmentQuestion.questionType.toString()),
      options: typesOptions,
      internalLabel: true,
      required: true
    },
  ];



  return (<>

    <Modal
      open={open}
      onClose={onClose}
      title={t('T_edit_question')}
      maxWidth="lg"
      children={<Stack spacing={2} p={2} >
        <Form fields={basicFields} onChange={onChanges} />
      </Stack>}
      actions={
        <Grid container alignItems={'center'} justifyContent={'space-between'} px={1} >
          <MuiButton variant="contained"
            sx={{ bgcolor: 'warning.main', color: 'white' }}
            size='large' onClick={onClose}>
            {t('T_cancel')}
          </MuiButton>
          <MuiButton variant="contained"
            sx={{ bgcolor: 'primary.main', color: 'white' }}
            disabled={loading}
            size='large' onClick={onSubmit}>
            {t('T_edit')}
            <CircularProgress
              size={10}
              sx={{ mx: 2, display: loading ? "" : "none" }}
            />
          </MuiButton>

        </Grid>
      }
    />
  </>
  );
};

export default EditIndustry;
